





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GenerateContractDialog from '@/modules/machinery/components/rental/GenerateContractDialog.vue';
import GenerateContractEndingDialog from '@/modules/machinery/components/rental/GenerateContractEndingDialog.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';

@Component({
  components: {
    GenerateContractDialog,
    GenerateContractEndingDialog,
    PdfViewer,
  },
})
export default class RentalDocumentViewer extends Vue {
  @Prop({ required: true })
  private item!: IMachineryRentalDto;
  private selectedDocument: string = 'contract';
  private documentAsUrl: string = '';
  private loadingDocument: boolean = false;
  private pdfSize: number = 450;

  public reload() {
    this.loadDocument();
  }

  private created() {
    this.pdfSize = window.innerHeight - 275;
    this.loadDocument();
  }

  private openDocument() {
    if (this.selectedDocument === 'contract') {
      (this.$refs.GenerateContractDialog as GenerateContractDialog).show();
    }
    if (this.selectedDocument === 'contract-ending') {
      (this.$refs.GenerateContractEndingDialog as GenerateContractEndingDialog).show();
    }
  }

  private generateDocument() {
    if (this.selectedDocument === 'contract') {
      (this.$refs.GenerateContractDialog as GenerateContractDialog).show();
    }
    if (this.selectedDocument === 'contract-ending') {
      (this.$refs.GenerateContractEndingDialog as GenerateContractEndingDialog).show();
    }
  }

  private async loadDocument() {
    try {
      this.loadingDocument = true;
      this.documentAsUrl = '';
      if (this.selectedDocument === 'contract') {
        const document = (await machineryRentalsRepository.downloadContract(this.$route.params.id)).data;
        this.documentAsUrl = window.URL.createObjectURL(document);
      }
      if (this.selectedDocument === 'contract-ending') {
        const document = (await machineryRentalsRepository.downloadContractEnding(this.$route.params.id)).data;
        this.documentAsUrl = window.URL.createObjectURL(document);
      }
    } catch {
      // Do nothing
    } finally {
      this.loadingDocument = false;
    }
  }

  private changed() {
    this.$emit('changed');
  }

  get hasSignedContract() {
    if (this.item && this.item.signedContractDocumentId && this.item.signedContractDocumentId !== '') {
      return true;
    }
    return false;
  }

  @Watch('selectedDocument')
  private onSelectionChanged(value: string) {
    this.loadDocument();
  }
}
